// Client side app startup file
// import 'babel-polyfill';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import Fingerprint2 from 'fingerprintjs2';
import Cookies from 'cookies-js';

import BaseApp from './helpers/BaseApp';
import makeStore from './helpers/createStore';

import Routes from '../shared/routes';
import config from '../config';

import { ensureDeviceId } from '../shared/utils/deviceId';
import { shouldSendLog } from '../shared/utils/errorReporting';

ensureDeviceId();

const DATADOG_CLIENT_TOKEN = 'pubabd2ab75cecf17fdaf80d0479a811e78';
const DATADOG_SITE = 'us3.datadoghq.com';
const DATADOG_SERVICE = 'legacy-web';
const DATADOG_ENV = process.env.CONFIG_SOURCE === 'production' ? 'prod' : process.env.CONFIG_SOURCE;

if (process.env.CONFIG_SOURCE === 'production' || process.env.CONFIG_SOURCE === 'prod') {
    datadogLogs.init({
        clientToken: DATADOG_CLIENT_TOKEN,
        site: DATADOG_SITE,
        service: DATADOG_SERVICE,
        env: DATADOG_ENV,
        version: config.appCodePath,
        sessionSampleRate: 100,
        forwardErrorsToLogs: true,
        beforeSend: shouldSendLog,
    });

    datadogRum.init({
        applicationId: '61d4c69b-9399-4482-8673-32788b48cb20',
        clientToken: DATADOG_CLIENT_TOKEN,
        site: DATADOG_SITE,
        service: DATADOG_SERVICE,
        env: DATADOG_ENV,
        version: config.appCodePath,
        allowedTracingUrls: ['https://api.utrsports.net', /https:\/\/.*\.utrsports\.net/, (url) => url.startsWith('https://api.utrsports.net')],
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        // Tracker beacons keep the page "active" after paint and inflate
        // @view.loading_time 2-4s past LCP (FEWD-261). This removes them from
        // the SDK's activity computation only — requests still fire and still
        // appear as RUM resources; a beforeSend filter cannot achieve this.
        // Kept in the activity set: maps.googleapis.com (page content) and
        // featureassets.org (Statsig gate fetch decides what renders).
        excludedActivityUrls: [
            /https:\/\/([a-z0-9-]+\.)*clarity\.ms([/:?]|$)/,
            /https:\/\/www\.googletagmanager\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*google-analytics\.com([/:?]|$)/,
            /https:\/\/analytics\.google\.com([/:?]|$)/,
            /https:\/\/www\.google\.com\/(ccm|rmkt|pagead)/,
            /https:\/\/([a-z0-9-]+\.)*doubleclick\.net([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*googlesyndication\.com([/:?]|$)/,
            /https:\/\/www\.googleadservices\.com([/:?]|$)/,
            /https:\/\/connect\.facebook\.net([/:?]|$)/,
            /https:\/\/www\.facebook\.com\/tr([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*amazon-adsystem\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*enzuzo\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*quantserve\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*quantcount\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*srvb1\.com([/:?]|$)/,
            /https:\/\/([a-z0-9-]+\.)*rubiconproject\.com([/:?]|$)/,
            /https:\/\/prodregistryv2\.org([/:?]|$)/,
        ],
        defaultPrivacyLevel: 'mask-user-input',
    });
}

const store = makeStore();

new Fingerprint2().get((fingerprint) => {
    Cookies.set('_fingerprint', fingerprint, { domain: window.APP_HOST_NAME, secure: process.env.CONFIG_SOURCE === 'production' || process.env.CONFIG_SOURCE === 'prod' });
});

const renderApp = () => ReactDOM.hydrate(
    <BaseApp store={store} routes={Routes} />,
    document.querySelector('#root'),
);

renderApp();

if (module.hot) {
    module.hot.accept('../shared/routes', () => {
        renderApp();
    });
}
